<template>
  <el-container style="height: 100vh">
    <el-aside width="200px">
      <div style="padding: 16px; font-weight: 700">宜束芸后台</div>
      <el-menu :default-active="active" router>
        <el-menu-item index="/dashboard">数据统计</el-menu-item>
        <el-menu-item index="/banner">轮播图</el-menu-item>
        <el-menu-item index="/category">分类</el-menu-item>
        <el-menu-item index="/product">商品</el-menu-item>
        <el-menu-item index="/user">用户</el-menu-item>
        <el-menu-item index="/agent">代理管理</el-menu-item>
        <el-menu-item index="/order">订单管理</el-menu-item>
        <el-menu-item index="/commission">积分管理</el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header style="display:flex;align-items:center;justify-content:flex-end">
        <el-button type="danger" text @click="onLogout">退出登录</el-button>
      </el-header>

      <el-main style="background:#f5f7fa">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "../store/auth";

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const active = computed(() => route.path);

const onLogout = () => {
  auth.logout();
  router.replace("/login");
};
</script>
